import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { StyleSheet, css } from 'aphrodite';
import ToolTips from 'components/ToolTips';
import { generateTextID } from 'utilities';

class TextAreaInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            requiredAlert: false
        };
    }
    componentDidUpdate() {
        const { value, showRequired } = this.props;
        const { requiredAlert } = this.state;
        // if showRequired is true, the input will always be red if value is === ''
        showRequired && !requiredAlert && value === '' && this.setState({ requiredAlert: true });
        showRequired && requiredAlert && value !== '' && this.setState({ requiredAlert: false });
    }
    render() {
        const {
            intl,
            theme,
            placeholder,
            value,
            onChange,
            width,
            height,
            title,
            fontSize,
            name,
            maxLength,
            showMaxLength,
            tooltip,
            required,
            margin,
            optionalText,
            noBorder,
            disabled,
            disabledStyling,
            onFocusProp,
            onBlurProp,
            titleFontSize,
            onKeyDown,
            autoFocus,
            autoComplete,
            noPadding,
            preventResize,
            className,
            labelStyles
        } = this.props;
        const { requiredAlert } = this.state;
        let randomID = generateTextID();
        this.styles = styles(theme, requiredAlert, fontSize, titleFontSize, disabledStyling);
        return (
            <div
                className={css(this.styles.inputWrapper)}
                style={{
                    width: width,
                    height: height,
                    margin: margin || className ? '0' : title !== '' ? '7px 0' : '0 0 7px 0'
                }}>
                {title && title !== '' && (
                    <div className={css(this.styles.titleTop)} style={labelStyles} id={randomID}>
                        {title}
                        {required && ` (${intl.formatMessage({ id: 'form.required' })})`}
                        {optionalText && ` ${intl.formatMessage({ id: 'form.option' })}`}
                    </div>
                )}
                {title && title !== '' && tooltip && tooltip !== '' && <ToolTips target={randomID} message={tooltip} />}
                <textarea
                    className={(className || css(this.styles.inputClass)) + ' inputClassComponent'}
                    onFocus={() => {
                        this.setState({ requiredAlert: false });
                        onFocusProp && onFocusProp();
                    }}
                    onBlur={() => {
                        required && this.setState({ requiredAlert: value === '' });
                        onBlurProp && onBlurProp();
                    }}
                    onKeyDown={onKeyDown}
                    style={{
                        fontSize: fontSize,
                        margin: title !== '' ? '7px auto 0 auto' : '0 auto',
                        padding: title !== '' ? '10px 0 7px 0' : noPadding ? '0' : '7px 0',
                        outline: 'none',
                        color: !requiredAlert ? theme.color.fontColor : 'red',
                        transition: '.2s color ease-in-out, .2s width ease-in-out, .2s border-bottom ease-in-out',
                        border: 'none',
                        borderBottom: noBorder ? 'none' : `1px solid ${!requiredAlert ? theme.color.borderColor : 'red'}`,
                        resize: preventResize && 'none',
                        display: 'block',
                        width: '100%',
                        outline: 'none',
                        background: 'none',
                        opacity: disabledStyling ? 0.5 : 1,
                    }}
                    id={'textAreaInput' + randomID}
                    name={name}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    disabled={disabled ? true : false}
                    autoFocus={autoFocus ? true : false}
                    autoComplete={autoComplete ? autoComplete : null}
                />
                {maxLength && showMaxLength && (
                    <div className={css(this.styles.characterCount)}>
                        {value.length} / {maxLength}
                    </div>
                )}
            </div>
        );
    }
}

TextAreaInput.defaultProps = {
    fontSize: 15,
    title: '',
    placeholder: '',
    value: 'Value',
    width: '100%'
};

const mapStateToProps = ({ app }) => {
    const { theme } = app;
    return { theme };
};

export default injectIntl(connect(mapStateToProps)(TextAreaInput));

const styles = (theme, requiredAlert, fontSize, titleFontSize, disabledStyling) =>
    StyleSheet.create({
        inputWrapper: {
            position: 'relative',
            display: 'grid',
            transition: '.2s color ease-in-out, .2s width ease-in-out'
        },
        titleTop: {
            position: 'absolute',
            top: -4,
            backgroundColor: theme.color.headerColor,
            width: '100%',
            textAlign: 'left',
            color: !requiredAlert ? theme.color.themeColor : 'red',
            transition: '.2s color ease-in-out',
            fontSize: titleFontSize || 12,
            opacity: disabledStyling ? 0.5 : 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        inputClass: {
            '::placeholder': {
                transition: '.2s color ease-in-out, .2s width ease-in-out',
                color: !requiredAlert ? theme.color.subFontColor : `rgba(255,0,0,0.55)`,
                fontSize: fontSize
            },
            ':-webkit-autofill': {
                '-webkit-box-shadow': `0px 0px 0px 50px ${theme.color.compColor} inset !important`,
                '-webkit-text-fill-color': !requiredAlert ? theme.color.fontColor : 'red',
                caretColor: !requiredAlert ? theme.color.fontColor : 'red'
            }
        },
        characterCount: {
            position: 'absolute',
            right: 0,
            bottom: 7,
            marginRight: 10
        }
    });
